export const CATEGORIES = [
  { value: "skills-expertise", label: "Skills & Expertise" },
  { value: "assets-space", label: "Assets & Space" },
  { value: "capital-opportunities", label: "Capital & Opportunities" },
  { value: "knowledge-mentorship", label: "Knowledge & Mentorship" },
  { value: "products-goods", label: "Products & Goods" },
  { value: "services", label: "Services" },
  { value: "other", label: "Other" },
];

export const CATEGORY_LABELS = Object.fromEntries(CATEGORIES.map((c) => [c.value, c.label]));
